module.exports = __webpack_public_path__ + "img/1 (37).6148d465.png";